<template>
  <div id="app">
    <div class="container">
      <nav class="navbar">
        <div class="navbar-brand">
          <router-link class="navbar-item" to="/">
            <img src="./assets/logo.svg">
            <div class="nav-logo-text">&nbsp;MAKEPEACE WITH CHESS</div>
          </router-link>
          <div class="navbar-burger" v-bind:class="{ 'is-active': showLinksMenu }" v-on:click="toggleBurger()">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div class="navbar-menu" v-bind:class="{ 'is-active': showLinksMenu }">

          <div class="navbar-start"></div>
          
          <div class="navbar-end">
            <router-link class="navbar-item" @click.native="toggleBurger()" to="/">Home</router-link>
            <router-link class="navbar-item" @click.native="toggleBurger()" to="/phil">About Phil</router-link>
            <router-link class="navbar-item" @click.native="toggleBurger()" to="/services">Services</router-link>
            <router-link class="navbar-item" @click.native="toggleBurger()" to="/contact">Contact</router-link>
          </div>
        
        </div>
      </nav>
    </div>
    
     <section class="hero is-dark is-fullwidth" v-if="$route.path == '/'">
      <div class="hero-body">
        <div class="container">
          <!-- <h1 class="title">Makepeace With Chess</h1> -->
          <div class="columns">
            <div class="column is-half">
              <div class="logo-banner">
                <h1 class="title logo-text is-marginless is-paddingless">MAKEPEACE<br/>WITH CHESS</h1>
                <img src="./assets/logo-white.svg" class="logo is-marginless is-paddingless">
              </div>
              <h2 class="subtitle">Professional chess coaching in London</h2>
            </div>
              
            <div class="column is-half">
              <h2 class="subtitle">
                <ul class="chess-list">
                  <li>Chess clubs in schools</li>
                  <li>One-to-one coaching</li>
                  <li>Online courses</li>
                </ul>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section> 
    <div class="section main">
      <router-view></router-view>
    </div>

    <footer class="footer mpwc-footer">
      <div class="container">
        <div class="columns">
          <div class="column is-6">
            <div class="logo-banner">
              <h1 class="title logo-text is-marginless is-paddingless">MAKEPEACE<br/>WITH CHESS</h1>
              <img src="./assets/logo.svg" class="logo is-marginless is-paddingless">
            </div>
            <p>Professional chess coaching in London</p>
            <p><a href="mailto:makepeacewithchess@gmail.com">makepeacewithchess@gmail.com</a></p>
            <br/>
            <div>
              <a class="button">
                <span class="icon">
                  <i class="fa fa-facebook"></i>
                </span>
              </a>
              <a class="button" href="https://twitter.com/ChessCoaches" target="_blank">
                <span class="icon">
                  <i class="fa fa-twitter"></i>
                </span>
              </a>
              <a class="button" href="http://makepeacewithchess.com/contact">
                <span class="icon">
                  <i class="fa fa-envelope"></i>
                </span>
              </a>
            </div>
            <div class="container"></div>
          </div>
          <div class="column is-5">
            <a class="twitter-timeline" data-height="360" href="https://twitter.com/ChessCoaches">Tweets by ChessCoaches</a>
          </div>
        </div>
      </div>
      <br/><br/>
      <div class="content has-text-centered sticky-bottom">
        <p class="is-size-7"><span>© 2018-{{new Date().getFullYear()}} Makepeace With Chess Ltd.</span> <span>All rights reserved.</span><!--<span>Site developed by <a href="http://www.linkedin.com/in/matt-curtis-4252973a">Matt Curtis</a></span>--></p>
         <!-- Website by <a href="http://mattcurtis.net" target="_blank">Matt Curtis</a>.</p> -->
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      showLinksMenu: false
    }
  },
  methods: {
    toggleBurger: function (event) {
      this.showLinksMenu = !this.showLinksMenu
    }
  }
}
</script>

<style lang="sass">

@import '../node_modules/bulma/sass/utilities/initial-variables.sass'

// $primary: #FFC145 // pastel orange
$primary: #F2545B
$dark: #2D3142 // gunmetal

@import "../node_modules/bulma/bulma.sass"

.navbar-item
  text-align: right

.mpwc-footer
  padding-bottom: 24px

.logo-banner
  height: 80px
  width: 300px
  position: relative
  font-family: Georgia, Times, "Times New Roman", serif

.logo-text
  position: absolute
  left: 0
  top: 6px
  padding: 0
  

img.logo
  position: absolute
  left: 225px
  top: 0
  padding: 0
  height: 80px
  width: 80px

.nav-logo-text
  font-family: Georgia, Times, "Times New Roman", serif
  font-size: 125%
</style>



// WEBPACK FOOTER //
// App.vue?045e5af4